import React, { useEffect, useState } from 'react'
import { $depositBonusClient, depositBonusClientMounted } from './model'
import { useStore } from 'effector-react'
import { CButton, CCol, CRow } from '@coreui/react-pro'
import { Space, Typography } from 'antd'
import { UpdateModal } from './widgets/updateModal'
import { useParams } from 'react-router-dom'
import { BlockAndUnblockModal } from './widgets/blockAndUnblockModal/component'
import { role } from '../../../../libs'
import { $userRole } from '../../../../features/user'

export const DepositBonus = () => {
  const [isOpen, setIsOpen] = useState({
    updateModalVisible: false,
    banModalVisible: false,
  })

  const { clientID } = useParams()
  const depositBonusClient = useStore($depositBonusClient)

  useEffect(() => {
    depositBonusClientMounted()
  }, [])
  const userRole = useStore($userRole)

  return (
    <>
      <CRow className="mb-3">
        <CCol sm={3}>
          <Typography.Title level={4}>Individual bonus</Typography.Title>
          <Space direction="vertical">
            <Typography.Text>
              {`Bonus percent: ${depositBonusClient.bonusPercent}`}
            </Typography.Text>
            <Typography.Text>
              {`Activation date: ${
                depositBonusClient.personalBonusEnabledAt || 'no data'
              }`}
            </Typography.Text>
            <Typography.Text>
              {`Comment: ${
                depositBonusClient.personalBonusComment || 'no data'
              }`}
            </Typography.Text>
          </Space>
        </CCol>
        <CCol sm={3}>
          <Typography.Title level={4}>Promo code bonus</Typography.Title>
          <Space direction="vertical">
            <Typography.Text>
              {`Code: ${
                depositBonusClient.userPromoCode?.promoCode?.code || 'no data'
              }`}
            </Typography.Text>
            <Typography.Text>
              {`Bonus percent: ${
                depositBonusClient.userPromoCode?.promoCode?.bonusPercent ||
                'no data'
              }`}
            </Typography.Text>
            <Typography.Text>
              {`Activation date: ${
                depositBonusClient.userPromoCode?.promoCode?.humanUpdatedAt ||
                'no data'
              }`}
            </Typography.Text>
          </Space>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm={3}>
          <Space direction="horizontal">
            <CButton
              color="success"
              hidden={
                userRole != undefined &&
                (userRole.indexOf(role.verificatorManager.verificatorAgent()) >=
                  0 ||
                  userRole.indexOf(role.partnership.juniorPartnerManager()) >=
                    0 ||
                  userRole.indexOf(role.partnership.seniorPartnerManager()) >=
                    0)
              }
              onClick={() =>
                setIsOpen((prevState) => ({
                  ...prevState,
                  updateModalVisible: true,
                }))
              }
            >
              Personal bonus
            </CButton>
            <CButton
              color="danger"
              hidden={
                userRole != undefined &&
                (userRole.indexOf(role.verificatorManager.verificatorAgent()) >=
                  0 ||
                  userRole.indexOf(role.partnership.juniorPartnerManager()) >=
                    0 ||
                  userRole.indexOf(role.partnership.seniorPartnerManager()) >=
                    0)
              }
              onClick={() =>
                setIsOpen((prevState) => ({
                  ...prevState,
                  banModalVisible: true,
                }))
              }
            >
              Block/Unblock
            </CButton>
          </Space>
        </CCol>
      </CRow>
      {isOpen.updateModalVisible && (
        <UpdateModal
          isVisible={isOpen.updateModalVisible}
          onClose={() =>
            setIsOpen((prevState) => ({
              ...prevState,
              updateModalVisible: false,
            }))
          }
          clientId={`${clientID}`}
        />
      )}
      {isOpen.banModalVisible && (
        <BlockAndUnblockModal
          isVisible={isOpen.banModalVisible}
          onClose={() =>
            setIsOpen((prevState) => ({
              ...prevState,
              banModalVisible: false,
            }))
          }
          clientId={`${clientID}`}
          isBanned={depositBonusClient.isBanned}
        />
      )}
    </>
  )
}
